import { render, staticRenderFns } from "./editHomeWindowPromotion.vue?vue&type=template&id=9a581bc8&scoped=true&"
import script from "./editHomeWindowPromotion.vue?vue&type=script&lang=js&"
export * from "./editHomeWindowPromotion.vue?vue&type=script&lang=js&"
import style0 from "./editHomeWindowPromotion.vue?vue&type=style&index=0&id=9a581bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a581bc8",
  null
  
)

component.options.__file = "editHomeWindowPromotion.vue"
export default component.exports